'use client'

import { ButtonV4 } from '@/components/v4/atoms/button/button'
import { RealWeddingsFilters } from '@/components/v3/organisms/real-weddings-filters/real-weddings-filters'
import s from './subcategory-filters-wrapper.module.css'
import { FiltersIconNew } from '@/components/svg/filters-icon-new/filters-icon-new'
import { useModal } from '@/hooks/use-modal'
import { useRouter, useSearchParams } from 'next/navigation'
import { ensureQueryArray } from '@/utils/ensureQueryArray'
import { XIconNew } from '@/components/svg/x-icon-new/x-icon-new'
import qs from 'qs'
import { usePathname } from 'next/navigation'
import { Tag } from '@/types/Tag'
import { VisibleOn } from '@/components/v3/atoms/visible-on'

type Props = {
  tags: Tag[]
}

export const SubcategoryFiltersWrapper = ({ tags }: Props) => {
  const modal = useModal()
  const query = useSearchParams()
  const router = useRouter()
  const pathName = usePathname()
  const queryParamTags = ensureQueryArray(query?.getAll('tag'))

  const handleRemoveFilter = (tagId: number) => {
    const tagToRemove = tags.find((placement) => placement.id === tagId)?.id
    const newTags = queryParamTags.filter((tag) => +tag !== tagToRemove)

    router.push(
      `${pathName}?${qs.stringify(
        { tag: newTags },
        { indices: false, skipNulls: true }
      )}`,
      { scroll: false }
    )
  }

  return (
    <>
      <VisibleOn desktop>
        <RealWeddingsFilters tags={tags} />
      </VisibleOn>

      <VisibleOn mobile tablet>
        <ButtonV4
          variant="dark"
          onClick={() =>
            modal.open('real-weddings-filters', {
              modalProps: { realWeddingsFilters: tags },
            })
          }
          className={s.button}
        >
          <FiltersIconNew />
          Filters
        </ButtonV4>
        <div className={s.chipWrapper}>
          {queryParamTags.map((tagId) => (
            <button
              key={tagId}
              className={s.chip}
              onClick={() => handleRemoveFilter(+tagId)}
            >
              {tags.find((placement) => placement.id === Number(tagId))?.name}
              <XIconNew />
            </button>
          ))}
        </div>
      </VisibleOn>
    </>
  )
}
